<template>
  <div class="space-y-3">
    <!-- İndirimli/Normal Fiyat Gösterimi -->
    <div class="flex flex-wrap items-baseline gap-3">
      <span class="text-3xl font-semibold text-orange-500">
        {{ formatPrice(hasDiscount ? discountedPrice : originalPrice) }}
      </span>

      <div v-if="hasDiscount" class="flex items-center gap-2">
        <span class="text-sm text-gray-400 line-through">
          {{ formatPrice(originalPrice) }}
        </span>

        <span class="inline-flex items-center px-2 py-1 text-xs font-medium text-orange-700 bg-orange-50 rounded">
          %{{ discountPercentage }} indirim
        </span>
      </div>
    </div>

    <!-- KDV ve Kargo Bilgisi -->
    <div class="flex items-center gap-2 text-sm text-gray-500">
      <span>KDV Dahil</span>
      <span class="text-gray-300">·</span>
      <span class="text-orange-500 font-medium">Ücretsiz Kargo</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  originalPrice: {
    type: Number,
    required: true
  },
  discountedPrice: {
    type: Number,
    default: null
  }
})

const hasDiscount = computed(() => props.discountedPrice && props.discountedPrice < props.originalPrice)

const discountPercentage = computed(() => {
  if (!hasDiscount.value) return 0
  return Math.round(((props.originalPrice - props.discountedPrice) / props.originalPrice) * 100)
})
</script>
